// /dashboard/:orgSlug/analytics — Figma frames 11 overview (33:331) and
// 12 corpus-too-small (33:393). Owner: screens-analytics, US-110 + US-111.
//
// The range lives in the URL rather than in component state, so a 90-day view
// survives a paste into a new tab and the browser back button returns to the
// range that was being looked at.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { AnalyticsScreen } from "../screens/analytics/AnalyticsScreen";
import {
  DEFAULT_RANGE,
  isRangeDays,
  type RangeDays,
} from "../screens/analytics/RangeChips";

export const analyticsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/analytics",
  staticData: { title: "Analytics" },
  validateSearch: (search: Record<string, unknown>): { days: RangeDays } => {
    const raw = Number(search.days);
    return { days: isRangeDays(raw) ? raw : DEFAULT_RANGE };
  },
  component: AnalyticsRoute,
});

function AnalyticsRoute() {
  const { orgSlug } = analyticsRoute.useParams();
  const { days } = analyticsRoute.useSearch();
  const navigate = analyticsRoute.useNavigate();

  return (
    <AnalyticsScreen
      orgSlug={orgSlug}
      days={days}
      onRangeChange={(next) => navigate({ search: { days: next } })}
    />
  );
}
